import * as ActionTypes from './actionTypes';

const putPendingUsers = (users) => ({
  type: ActionTypes.PUT_PENDING_USERS,
  users,
});

const removePendingUser = (id) => ({
  type: ActionTypes.REMOVE_PENDING_USER,
  id,
});

const setSearch = (search) => ({
  type: ActionTypes.SET_VERIFICATION_SEARCH,
  search,
});

export default {
  putPendingUsers,
  removePendingUser,
  setSearch,
};
